import { IsNumber, IsOptional, IsString } from 'class-validator';

export class FireOpenOrderPaymentRequestDto {
  @IsString()
  description: string;

  @IsNumber()
  orderId: number;

  @IsNumber()
  @IsOptional()
  customerId?: number;

  @IsString()
  @IsOptional()
  baseUrl?: string;

  @IsOptional()
  @IsString()
  currency?: string;

  @IsOptional()
  @IsString()
  myRef?: string;

  @IsOptional()
  @IsString()
  returnUrl?: string;

  @IsOptional()
  @IsNumber()
  paymentMethodId?: number;
}
